var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-indicator d-flex mx-1",class:{ 'active': _vm.active, 'inactive': !_vm.active }},[_c('span',{staticClass:"my-auto mx-auto"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }